export default __webpack_public_path__ + "static/media/bronze-nft.3b49ecb3.png";